import { css } from '@emotion/css';

export const fullPage = css`
  #content,
  #content.full-size {
    border-radius: 0;
  }
`;
